export default __webpack_public_path__ + "static/media/buy-sell.3dc4d3dc.svg";